import { render, staticRenderFns } from "./ClubCardGettingEmailEnter.vue?vue&type=template&id=bf74c150&"
import script from "./ClubCardGettingEmailEnter.vue?vue&type=script&lang=js&"
export * from "./ClubCardGettingEmailEnter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf74c150')) {
      api.createRecord('bf74c150', component.options)
    } else {
      api.reload('bf74c150', component.options)
    }
    module.hot.accept("./ClubCardGettingEmailEnter.vue?vue&type=template&id=bf74c150&", function () {
      api.rerender('bf74c150', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/Club/components/core/ClubCardGetting/components/common/ClubCardGettingEmailEnter.vue"
export default component.exports